export default {"src":"/_next/static/image/public/images/flags/flag_966.a24c8aee0abb6060be12a6b1e5d1f9e0.svg","height":16,"width":24};